import { z } from "zod";
import { DocumentParentTypeSchema } from "./document.types.js";
/**
 * Hard cap enforced both via Zod (declaration check on `upload-url`) and at signing time via
 * `Content-Length` pinned in the presigned URL (Scaleway rejects the PUT if the actual upload
 * size doesn't match).
 */
export const MAX_DOCUMENT_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const ACCEPTED_DOCUMENT_MIME_TYPES = [
    "image/jpeg",
    "image/png",
    "image/heic",
    "image/webp",
    "image/gif",
    "application/pdf",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
];
const parentRefShape = {
    parentType: DocumentParentTypeSchema,
    parentId: z.string().min(1),
};
export const CreateTextDocumentPayloadSchema = z.object({
    ...parentRefShape,
    body: z.string().min(1),
});
export const CreateUploadUrlPayloadSchema = z.object({
    ...parentRefShape,
    filename: z.string().min(1),
    mimeType: z.enum(ACCEPTED_DOCUMENT_MIME_TYPES),
    sizeBytes: z.number().int().positive().max(MAX_DOCUMENT_FILE_SIZE_BYTES),
});
export const UpdateTextDocumentPayloadSchema = z.object({
    body: z.string().min(1),
});
export const DownloadUrlResponseSchema = z.object({
    downloadUrl: z.string().url(),
});
export const PrepareDocumentUploadPayloadSchema = z.object({
    ...parentRefShape,
    uploadId: z.string().uuid(),
    filename: z.string().min(1).max(255),
    mimeType: z.enum(ACCEPTED_DOCUMENT_MIME_TYPES),
    sizeBytes: z.number().int().positive().max(MAX_DOCUMENT_FILE_SIZE_BYTES),
    checksumSha256: z.string().regex(/^[a-f0-9]{64}$/),
});
//# sourceMappingURL=document.payloads.js.map